<template>
  <header class="header-global" ref="headerEl">
    <base-nav
      :class="['navbar-main', { 'navbar-scrolled': isScrolled }]"
      transparent
      effect="dark"
      expand
    >
      <router-link
        slot="brand"
        class="navbar-brand mr-lg-5"
        :to="{ name: 'public-components' }"
      >
        <img
          src="@/assets/bjp/Logo-oficial.png"
          alt="Logo oficial del Bono Juancito Pinto"
          class="navbar-logo"
        />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="#">
            <img
              src="@/assets/bjp/Logo-oficial.png"
              alt="Logo oficial del Bono Juancito Pinto"
            />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li class="nav-item">
          <router-link
            :to="{ name: 'public-components' }"
            class="nav-link nav-link-icon"
            :class="{ 'is-current': $route.name === 'public-components' }"
            >Inicio</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'public-search' }"
            class="nav-link nav-link-icon"
            :class="{ 'is-current': $route.name === 'public-search' }"
            >Consultar</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'public-info' }"
            class="nav-link nav-link-icon"
            :class="{ 'is-current': $route.name === 'public-info' }"
            >Requisitos</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'public-entities' }"
            class="nav-link nav-link-icon"
            :class="{ 'is-current': $route.name === 'public-entities' }"
            >Entidades Autorizadas</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'public-contacts' }"
            class="nav-link nav-link-icon"
            :class="{ 'is-current': $route.name === 'public-contacts' }"
            >Contactos</router-link
          >
        </li>
      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item d-none d-lg-block ml-lg-4">
          <a
            :href="externalUrl"
            rel="noopener"
            class="btn btn-primary btn-ingresar"
          >
            <span class="nav-link-inner--text">Acceso institucional</span>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script setup>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import { ref, onMounted, onUnmounted } from "vue";

const externalUrl = process.env.VUE_APP_ADMIN_FRONT_URL;
const isScrolled = ref(false);
const headerEl = ref(null);
const emit = defineEmits(["update-header-height"]);

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  if (headerEl.value) {
    const resizeObserver = new ResizeObserver(() => {
      emit("update-header-height", headerEl.value.offsetHeight);
    });
    resizeObserver.observe(headerEl.value);
  }
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>
<style scoped>
.header-global {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* Ensure it stays on top */
}
.navbar-main {
  position: relative !important;
  background: #062f36 !important;
  border-bottom: 1px solid rgba(230, 203, 114, 0.2);
  box-shadow: 0 8px 32px rgba(27, 36, 30, 0.12);
  backdrop-filter: blur(18px) saturate(1.15);
  -webkit-backdrop-filter: blur(18px) saturate(1.15);
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.navbar-scrolled {
  background: #062f36 !important;
  box-shadow: 0 10px 34px rgba(6, 47, 54, 0.24);
}

.navbar-logo {
  width: 180px;
  max-height: 72px;
  height: auto;
  object-fit: contain;
}

.navbar-brand {
  padding: 0.42rem 0;
  border: 0;
  background: transparent;
}

.nav-link {
  color: #ffffff !important;
  font-weight: 650 !important;
  text-decoration: none !important;
  position: relative;
  padding-bottom: 0.5rem;
  border-radius: 8px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.nav-link.active,
.nav-link.is-current {
  color: #ffffff !important;
  background-color: rgba(6, 47, 54, 0.28);
}

.nav-link.active::after,
.nav-link.is-current::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0.5rem;
  right: 0.5rem;
  height: 2px;
  border-radius: 999px;
  background-color: var(--bjp-gold-400);
  box-shadow: none;
}
.btn-ingresar {
  border: 1px solid var(--bjp-gold-400);
  border-radius: 20px;
  background: var(--bjp-gold-400);
  color: var(--bjp-petrol-950) !important;
  transition: all 0.3s ease;
  padding: 0.55rem 1rem;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.04em;
}

.btn-ingresar:hover {
  border-color: var(--bjp-gold-200);
  background: var(--bjp-gold-200);
  color: var(--bjp-petrol-950) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.btn-ingresar:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 991.98px) {
  .navbar-main {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .navbar-logo {
    width: 155px;
    max-height: 62px;
  }

  .navbar-brand {
    padding: 0.32rem 0.55rem;
  }
}

@media (max-width: 400px) {
  .navbar-logo {
    width: 130px;
    max-height: 54px;
  }
}
</style>

<style>
@media (max-width: 991.98px) {
  .header-global .navbar-collapse.collapsing,
  .header-global .navbar-collapse.show {
    max-height: calc(100vh - 1.4rem);
    overflow-y: auto;
    border: 1px solid rgba(230, 203, 114, 0.28);
    border-radius: 18px;
    background: #062f36 !important;
    box-shadow: 0 24px 55px rgba(43, 53, 46, 0.2) !important;
  }

  .header-global .navbar-collapse-header {
    border-bottom-color: rgba(230, 203, 114, 0.16) !important;
  }

  .header-global .collapse-brand a {
    display: inline-block;
    padding: 0.35rem 0;
    background: transparent;
  }

  .header-global .navbar-collapse .nav-link {
    color: #ffffff !important;
    border-bottom: 1px solid rgba(230, 203, 114, 0.1);
  }

  .header-global .navbar-collapse .nav-link:hover,
  .header-global .navbar-collapse .nav-link.active,
  .header-global .navbar-collapse .nav-link.is-current {
    color: #ffffff !important;
  }

  .header-global .navbar-collapse .nav-link.active,
  .header-global .navbar-collapse .nav-link.is-current {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
    background: rgba(6, 47, 54, 0.28);
  }

  .header-global .navbar-collapse .collapse-close .navbar-toggler span {
    background: #e6cb72 !important;
    box-shadow: none;
  }
}

@media (max-width: 400px) {
  .header-global .navbar-collapse.collapsing,
  .header-global .navbar-collapse.show {
    padding: 1rem;
  }
}
</style>
